'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var reactRedux = require('react-redux');
var routerAdapter = require('@piconetworks/router-adapter');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);

  var _super = _createSuper(Component);

  function Component() {
    _classCallCheck(this, Component);

    return _super.apply(this, arguments);
  }

  _createClass(Component, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React__default['default'].cloneElement(children, Object.assign({}, this.props));
    }
  }]);

  return Component;
}(React__default['default'].Component);

var withConnect = function withConnect() {
  var mapStateToProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var mapDispatchToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var mergeProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return routerAdapter.withRouter(reactRedux.connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component));
};

Component.defaultProps = {
  children: null
};
Component.propTypes = {
  children: PropTypes__default['default'].node
};

var withInjection = function withInjection(InjectedComponent, _ref) {
  var _ref$mapStateToProps = _ref.mapStateToProps,
      mapStateToProps = _ref$mapStateToProps === void 0 ? null : _ref$mapStateToProps,
      _ref$mapDispatchToPro = _ref.mapDispatchToProps,
      mapDispatchToProps = _ref$mapDispatchToPro === void 0 ? null : _ref$mapDispatchToPro,
      _ref$mergeProps = _ref.mergeProps,
      mergeProps = _ref$mergeProps === void 0 ? null : _ref$mergeProps;
  var Injector = withConnect(mapStateToProps, mapDispatchToProps, mergeProps);

  var WithInjectionComponent = function WithInjectionComponent(props) {
    return /*#__PURE__*/React__default['default'].createElement(Injector, props, /*#__PURE__*/React__default['default'].createElement(InjectedComponent, null));
  };

  return WithInjectionComponent;
};

module.exports = withInjection;
